"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _victory = require("victory");

var _civicFormat = _interopRequireDefault(require("../utils/civicFormat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var PieChartLabel = function PieChartLabel(props) {
  var dataLabel = props.dataLabel,
      dataValue = props.dataValue,
      totalValue = props.totalValue,
      useLegend = props.useLegend,
      tooltip = props.tooltip,
      theme = props.theme;
  return _react["default"].createElement("g", null, tooltip ? _react["default"].createElement(_victory.VictoryTooltip, _extends({}, props, {
    pointerLength: 0,
    cornerRadius: 0,
    theme: theme,
    labelComponent: _react["default"].createElement(_victory.VictoryLabel, {
      text: function text(datum) {
        return "".concat(datum[dataLabel], ": ").concat(_civicFormat["default"].decimalToPercent(datum[dataValue] / totalValue));
      }
    })
  })) : null, !useLegend ? _react["default"].createElement(_victory.VictoryLabel, _extends({}, props, {
    style: _objectSpread({}, theme.pieLabel.style)
  })) : null);
};

PieChartLabel.defaultEvents = _victory.VictoryTooltip.defaultEvents;
PieChartLabel.propTypes = {
  dataLabel: _propTypes["default"].string,
  dataValue: _propTypes["default"].string,
  totalValue: _propTypes["default"].number,
  useLegend: _propTypes["default"].bool,
  tooltip: _propTypes["default"].bool,
  theme: _propTypes["default"].shape({})
};
var _default = PieChartLabel;
exports["default"] = _default;